'use client'

import { useEffect } from 'react'
import { initializeRpcSystem } from '@/utils/rpcInitializer'

/**
 * Component that initializes the RPC system on app startup
 * This component should be placed high in the component tree
 */
export const RpcInitializer: React.FC = () => {
  useEffect(() => {
    // Initialize RPC system when component mounts
    initializeRpcSystem().catch(console.error)
  }, [])

  // This component doesn't render anything
  return null
}

export default RpcInitializer
